module.exports = __webpack_public_path__ + "img/1527319337.52ba29a4.jpg";